import config from '../config';
import { handleResponse } from "./builder";

export const getFromId = async id => {

    const response = await fetch(`${config.apiUrl}/product/${id}`)

    return handleResponse(response);

}
